const NftMetaData = (props) => {
  return (
    <div>
      {props.contractName} / {props.symbol} / {props.contractType}
    </div>
  );
};

export default NftMetaData;
